<ng-container [ngSwitch]="balloon.segmentStatus">
  <ng-container *ngSwitchCase="EReplaySegmentStatus.Moving">
    <fm-replay-balloon-header titleText="Moving" [statusIcon]="balloon.segmentStatusIcon" i18n-titleText="@@S_MOVING">
      <ng-container title-content *ngIf="showStatsContainer && permissions?.showVehicleSpeed">
        •
        <span [ngClass]="{ 'speed-violation': balloon?.harshDrivingType === EHarshDrivingType.Speeding }">{{
          balloon?.speed | speedConvert: userSettings.SpeedUnits | number: '1.0-0' | speedUnits: userSettings.SpeedUnits
        }}</span>
      </ng-container>
      <ng-container subtitle-content *ngTemplateOutlet="headerSubtitleWithBattery"></ng-container>
    </fm-replay-balloon-header>
  </ng-container>
  <ng-container *ngSwitchCase="EReplaySegmentStatus.AssetMoving">
    <fm-replay-balloon-header titleText="Moving" [statusIcon]="balloon.segmentStatusIcon" i18n-titleText="@@S_MOVING">
      <ng-container title-content *ngIf="showStatsContainer && permissions?.showVehicleSpeed">
        •
        <span [ngClass]="{ 'speed-violation': balloon?.harshDrivingType === EHarshDrivingType.Speeding }">{{
          balloon?.speed | speedConvert: userSettings.SpeedUnits | number: '1.0-0' | speedUnits: userSettings.SpeedUnits
        }}</span>
      </ng-container>
      <span class="header-subtitle" subtitle-content>{{ startTime }}</span>
    </fm-replay-balloon-header>
  </ng-container>
  <ng-container *ngSwitchCase="EReplaySegmentStatus.Idle">
    <fm-replay-balloon-header titleText="Idle" [statusIcon]="balloon.segmentStatusIcon" i18n-titleText="@@S_IDLE">
      <ng-container title-content *ngIf="showStatsContainer && duration">
        •
        <ng-container *ngTemplateOutlet="durationString"></ng-container>
      </ng-container>
      <span class="header-subtitle" subtitle-content>{{ startTime }}</span>
    </fm-replay-balloon-header>
  </ng-container>
  <ng-container *ngSwitchCase="EReplaySegmentStatus.Stopped">
    <fm-replay-balloon-header titleText="Stopped" [statusIcon]="balloon.segmentStatusIcon" i18n-titleText="@@S_STOPPED">
      <ng-container title-content *ngIf="showStatsContainer && duration">
        •
        <ng-container *ngTemplateOutlet="durationString"></ng-container>
      </ng-container>
      <span class="header-subtitle" subtitle-content>{{ startTime }}</span>
    </fm-replay-balloon-header>
  </ng-container>
  <ng-container *ngSwitchCase="EReplaySegmentStatus.AssetJourneyEnd">
    <fm-replay-balloon-header titleText="Stopped" [statusIcon]="balloon.segmentStatusIcon" i18n-titleText="@@S_STOPPED">
      <span class="header-subtitle" subtitle-content>{{ startTime }}</span>
    </fm-replay-balloon-header>
  </ng-container>
  <ng-container *ngSwitchCase="EReplaySegmentStatus.Start">
    <fm-replay-balloon-header titleText="Start" [statusIcon]="balloon.segmentStatusIcon" i18n-titleText="@@S_START">
      <ng-container subtitle-content *ngTemplateOutlet="headerSubtitleWithBattery"></ng-container>
    </fm-replay-balloon-header>
  </ng-container>
  <ng-container *ngSwitchCase="EReplaySegmentStatus.End">
    <fm-replay-balloon-header titleText="End" [statusIcon]="balloon.segmentStatusIcon" i18n-titleText="@@S_END">
      <ng-container subtitle-content *ngTemplateOutlet="headerSubtitleWithBattery"></ng-container>
    </fm-replay-balloon-header>
  </ng-container>
  <ng-container *ngSwitchCase="EReplaySegmentStatus.Private">
    <fm-replay-balloon-header titleText="Private" [statusIcon]="balloon.segmentStatusIcon" i18n-titleText="@@S_PRIVATE">
      <ng-container subtitle-content *ngTemplateOutlet="headerSubtitleWithBattery"></ng-container>
    </fm-replay-balloon-header>
  </ng-container>
  <ng-container *ngSwitchCase="EReplaySegmentStatus.AssetLocationCheckIn">
    <fm-replay-balloon-header
      titleText="Location check-in"
      [statusIcon]="balloon.segmentStatusIcon"
      i18n-titleText="@@S_ASSETLOCATIONCHECKIN"
    >
      <span class="header-subtitle" subtitle-content>{{ startTime }}</span>
    </fm-replay-balloon-header>
  </ng-container>
  <ng-container *ngSwitchCase="EReplaySegmentStatus.Charging">
    <fm-replay-balloon-header titleText="Charging" [statusIcon]="balloon.segmentStatusIcon" i18n-titleText="@@S_CHARGING">
      <span class="header-subtitle" subtitle-content>{{ startTime }}</span>
    </fm-replay-balloon-header>
  </ng-container>
</ng-container>
<fm-balloon-section>
  <div class="balloon-data-container">
    <ng-container *ngIf="!balloon?.hasVideo">
      <ng-container *ngTemplateOutlet="address"></ng-container>
    </ng-container>
    <div class="stats__container" *ngIf="showStatsContainer">
      <ng-container *ngIf="balloon?.hasVideo">
        <ng-container *ngTemplateOutlet="address"></ng-container>
      </ng-container>
      <div>
        <ng-container *ngIf="balloon.segmentStatus === EReplaySegmentStatus.AssetLocationCheckIn">
          <ng-container *ngTemplateOutlet="gpsQuality"> </ng-container>
        </ng-container>
        <ng-container
          *ngIf="balloon?.harshDrivingType !== EHarshDrivingType.Speeding && balloon?.harshDrivingType !== EHarshDrivingType.None"
        >
          <ng-container *ngTemplateOutlet="harshDrivingInfo"></ng-container>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="balloon?.hasVideo">
      <div class="video-thumbnail">
        <div class="video-thumbnail__play-button__container">
          <mat-icon
            *ngIf="videoThumbnailLoaded"
            class="video-thumbnail__play-button mat-icon-size-xl"
            svgIcon="ic-video-play-button"
          ></mat-icon>
        </div>
        <fm-ghost-element-loader-image
          class="video-thumbnail__image"
          alt="replay balloon video thumbnail"
          [src]="balloon?.videoDetails?.thumbnailUrl"
          (click)="onVideoThumbnailClicked()"
          (loaded)="onVideoThumbnailLoaded()"
        ></fm-ghost-element-loader-image>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="balloon?.harshDrivingType === EHarshDrivingType.Speeding && permissions?.showVehicleSpeed">
    <ng-container *ngTemplateOutlet="postedSpeedLimit"></ng-container>
  </ng-container>
  <ng-container *ngIf="showBatteryLevelRangeSection">
    <ng-container *ngTemplateOutlet="batteryLevelRangeSection"></ng-container>
  </ng-container>
</fm-balloon-section>
<fm-balloon-actions class="actions">
  <button
    mat-button
    class="btn btn-tertiary btn-xs streetview-btn vzc-small"
    a7s-id="replay-balloon-streetview"
    i18n="@@S_STREETVIEW"
    [disabled]="!isStreetViewAvailable"
    (click)="onStreetViewClicked()"
  >
    Street View
  </button>
  <button
    mat-button
    class="btn btn-tertiary btn-xs previous-plot-btn vzc-small"
    a7s-id="replay-balloon-previous-plot"
    i18n="@@S_PREVIOUS"
    [disabled]="balloon.segmentStatus === EReplaySegmentStatus.Start"
    (click)="onPreviousPlotClicked()"
  >
    PREVIOUS
  </button>
  <button
    *ngIf="balloon?.hasVideo"
    mat-button
    class="btn btn-tertiary btn-xs go-to-video-event-btn vzc-small"
    a7s-id="replay-balloon-go-to-video-event"
    i18n="@@S_REPLAY_VIEWEVENT"
    (click)="onViewEventClicked()"
  >
    View Event
  </button>
  <button
    mat-button
    class="btn btn-tertiary btn-xs next-plot-btn vzc-small"
    a7s-id="replay-balloon-next-plot"
    [disabled]="balloon.segmentStatus === EReplaySegmentStatus.End || balloon.segmentStatus === EReplaySegmentStatus.InProgress"
    i18n="@@S_NEXT"
    (click)="onNextPlotClicked()"
  >
    NEXT
  </button>
  <button
    mat-button
    *ngIf="
      videoDeviceInfo.isVodRequestEnabled &&
      videoSegmentAvailable &&
      balloon.segmentStatus !== EReplaySegmentStatus.Private &&
      permissions?.videoGetVideo
    "
    class="btn btn-tertiary btn-xs go-to-video-event-btn vzc-small"
    a7s-id="replay-balloon-go-to-video-event"
    i18n="@@S_VOD_REQUEST_VIDEO"
    (click)="onRequestVideoClicked()"
  >
    Request Video
  </button>
</fm-balloon-actions>

<ng-template #miles>
  <span i18n="@@S_MILES">miles</span>
</ng-template>
<ng-template #kilometers>
  <span i18n="@@S_KILOMETERS">km</span>
</ng-template>
<ng-template #durationString>
  <ng-container *ngIf="isDurationMinsOnly"
    >{{ duration }}
    <ng-container i18n="@@S_MINS">mins</ng-container>
  </ng-container>
  <ng-container *ngIf="!isDurationMinsOnly">{{ duration }}</ng-container>
</ng-template>
<ng-template #address>
  <div class="address__container">
    <span>{{ balloon?.address }}</span>
  </div>
</ng-template>

<ng-template #gpsQuality>
  <div class="gps-quality__container">
    <span class="gps-quality__title"><span i18n="@@S_ASSET_GPS_ACCURACY">Accuracy</span>:</span>
    <ng-container [ngSwitch]="balloon?.plotData?.gpsQuality">
      <ng-container *ngSwitchCase="EGPSQuality.Normal">
        <span i18n="@@S_ASSET_GPS_QUALITY_ACCURATE" class="gps-quality__text">Accurate</span>
        <mat-icon class="gps-quality__icon mat-icon-size-xs" svgIcon="ic-signal-normal"></mat-icon>
      </ng-container>
      <ng-container *ngSwitchCase="EGPSQuality.Low">
        <span i18n="@@S_ASSET_GPS_QUALITY_POTENTIALLY_INACCURATE" class="gps-quality__text">Potentially Inaccurate</span>
        <mat-icon class="gps-quality__icon mat-icon-size-xs" svgIcon="ic-signal-low"></mat-icon>
      </ng-container>
      <ng-container *ngSwitchCase="EGPSQuality.Lost">
        <span i18n="@@S_ASSET_GPS_QUALITY_INACCURATE" class="gps-quality__text">Inaccurate</span>
        <mat-icon class="gps-quality__icon mat-icon-size-xs" svgIcon="ic-signal-lost"></mat-icon>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #postedSpeedLimit>
  <div class="balloon-info__container">
    <mat-icon class="balloon-info__icon mat-icon-size-xs" svgIcon="ic-replay-harsh-driving-event-exclamation" size></mat-icon>
    <span class="balloon-info__text">
      <span class="balloon-info__text__caption" i18n="@@S_POSTED_SPEED_LIMIT">Posted Speed Limit:</span>
      <span class="balloon-info__text__details">
        {{
          balloon?.postedSpeedLimit | speedConvert: userSettings.SpeedUnits | number: '1.0-0' | speedUnits: userSettings.SpeedUnits
        }}</span
      >
    </span>
  </div>
  <span
    class="balloon-info__message"
    *ngIf="managePostedSpeedEnabled"
    a7s-id="EntrySource_Replay"
    i18n="@@S_MANAGE_POSTED_SPEED_MESSAGE_WITH_LINK"
    >To change the posted speed limit, go to <a (click)="onManagePostedSpeedClicked()">Manage posted speed</a>.</span
  >
</ng-template>

<ng-template #harshDrivingInfo>
  <div class="balloon-info__container">
    <mat-icon class="balloon-info__icon mat-icon-size-xs" svgIcon="ic-replay-harsh-driving-event-exclamation" size></mat-icon>
    <ng-container [ngSwitch]="balloon?.harshDrivingType">
      <span class="balloon-info__text" *ngSwitchCase="EHarshDrivingType.HardAccelerationModerate">
        <span class="balloon-info__text__caption" i18n="@@S_EVENTCODE_HARDACCELERATION">Hard acceleration event</span>:
        <span class="balloon-info__text__details" i18n="@@S_MODERATE">Moderate</span>
      </span>
      <span class="balloon-info__text" *ngSwitchCase="EHarshDrivingType.HardAccelerationSevere">
        <span class="balloon-info__text__caption" i18n="@@S_EVENTCODE_HARDACCELERATION">Hard acceleration event</span>:
        <span class="balloon-info__text__details" i18n="@@S_ACCELERATIONSEVERITY_SEVERE">Severe</span>
      </span>
      <span class="balloon-info__text" *ngSwitchCase="EHarshDrivingType.HardBrakingModerate">
        <span class="balloon-info__text__caption" i18n="@@S_EVENTCODE_HARDBRAKING">Hard braking event</span>:
        <span class="balloon-info__text__details" i18n="@@S_MODERATE">Moderate</span>
      </span>
      <span class="balloon-info__text" *ngSwitchCase="EHarshDrivingType.HardBrakingSevere">
        <span class="balloon-info__text__caption" i18n="@@S_EVENTCODE_HARDBRAKING">Hard braking event</span>:
        <span class="balloon-info__text__details" i18n="@@S_ACCELERATIONSEVERITY_SEVERE">Severe</span>
      </span>
      <span class="balloon-info__text" *ngSwitchCase="EHarshDrivingType.HardCorneringModerate">
        <span class="balloon-info__text__caption" i18n="@@S_EVENTCODE_HARDCORNERING">Harsh cornering event</span>:
        <span class="balloon-info__text__details" i18n="@@S_MODERATE">Moderate</span>
      </span>
      <span class="balloon-info__text" *ngSwitchCase="EHarshDrivingType.HardCorneringSevere">
        <span class="balloon-info__text__caption" i18n="@@S_EVENTCODE_HARDCORNERING">Harsh cornering event</span>:
        <span class="balloon-info__text__details" i18n="@@S_ACCELERATIONSEVERITY_SEVERE">Severe</span>
      </span>
    </ng-container>
  </div>
</ng-template>

<ng-template #batteryLevelRangeSection>
  <fm-ev-battery-range-section
    [startTime]="evBatteryDataStartTime"
    [endTime]="evBatteryDataEndTime"
    [isChargingStart]="balloon.segmentEVData.start.charging"
    [isChargingEnd]="balloon.segmentEVData.end.charging"
    [startPercentage]="balloon.segmentEVData.start.batteryPercentage"
    [endPercentage]="balloon.segmentEVData.end.batteryPercentage"
    [userSettings]="userSettings"
  >
  </fm-ev-battery-range-section>
</ng-template>

<ng-template #batteryLevelHeader>
  <fm-ev-battery-section
    [isCharging]="balloon.plotData.evBatteryData.chargingState"
    [percentage]="balloon.plotData.evBatteryData.batteryPercentage"
    [userSettings]="userSettings"
    [showBatteryPercentageOnRightSide]="true"
  >
  </fm-ev-battery-section>
</ng-template>

<ng-template #headerSubtitleWithBattery>
  <div class="header-subtitle header-subtitle__with-charging">
    <span>{{ startTime }}</span>
    <ng-container *ngIf="balloon?.plotData?.evBatteryData"
      ><span class="header-subtitle header-subtitle__with-charging__divider">•</span>
      <ng-container *ngTemplateOutlet="batteryLevelHeader"></ng-container>
    </ng-container>
  </div>
</ng-template>
